import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import {
	DebugDataRequirementsCheckersSymbol,
	IDataRequirementsCheckersDebugMap,
	NavigationInfoSymbol,
	DSViewModeAPISymbol,
	LayoutDiagnosticSymbol,
	LayoutDiagnosticService,
	IViewMode,
} from '@wix/thunderbolt-symbols'
import type { INavigationInfo } from 'ds-feature-editor-navigation'
import { NavigationManagerSymbol, INavigationManager } from 'feature-navigation-manager'
import _ from 'lodash'

const viewerManagerDiagnosticsApiFactory = (
	{ getDataRequirementsCheckersDebugMap }: IDataRequirementsCheckersDebugMap,
	{ getCurrentRootNavigationInfo, isDuringInitialNavigationPhase }: INavigationInfo,
	navigationManager: INavigationManager,
	viewModeApi: IViewMode,
	layoutDiagnosticService: LayoutDiagnosticService
): IViewerManagerImplementor<'diagnostics'> => {
	const getFalsyDataRequirementCheckers = () => _.keys(_.omitBy(getDataRequirementsCheckersDebugMap()))
	return {
		diagnostics: {
			getDebugInfo: () => ({
				dataRequirementCheckers: getFalsyDataRequirementCheckers(),
				currentPageId: getCurrentRootNavigationInfo().pageId || 'not available',
				isDuringNavigation: navigationManager.isDuringNavigation(),
				isDuringViewModeSwitch: viewModeApi.isDuringViewModeSwitch(),
				isDuringInitialNavigationPhase: isDuringInitialNavigationPhase(),
				isDuringDataFetching: navigationManager.isDuringDataFetching(),
				...layoutDiagnosticService.getDiagnosticState(),
			}),
		},
	}
}

export const ViewerManagerDiagnosticsApi = withDependencies(
	[
		DebugDataRequirementsCheckersSymbol,
		NavigationInfoSymbol,
		NavigationManagerSymbol,
		DSViewModeAPISymbol,
		LayoutDiagnosticSymbol,
	],
	viewerManagerDiagnosticsApiFactory
)
